export default "__VITE_ASSET__Co_2XSvA__"